"use strict";
/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * ČVS - API
 * OpenAPI spec version: 1.1.529
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionRequestModule = void 0;
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.PermissionRequestModule = {
    ADMIN: 'ADMIN',
    ADMIN2: 'ADMIN2',
    ADMIN3: 'ADMIN3',
    ADMINOLD2: 'ADMINOLD2',
    ADRESAR: 'ADRESAR',
    ADRESAR2: 'ADRESAR2',
    ANKETA: 'ANKETA',
    ANKETA2: 'ANKETA2',
    API2: 'API2',
    API_MAIN: 'API_MAIN',
    BANKA2: 'BANKA2',
    BANNERY: 'BANNERY',
    BANNERY2: 'BANNERY2',
    BEACH2: 'BEACH2',
    BEACH_DELEGATI2: 'BEACH_DELEGATI2',
    BEACH_ROZHODCI2: 'BEACH_ROZHODCI2',
    BEACH_SLOZKY2: 'BEACH_SLOZKY2',
    BEACH_STATISTIKA2: 'BEACH_STATISTIKA2',
    COMM2: 'COMM2',
    DELEGATI2: 'DELEGATI2',
    DM: 'DM',
    DM2: 'DM2',
    DOKUMENTY2: 'DOKUMENTY2',
    ESCORE2: 'ESCORE2',
    HLASOVANI2: 'HLASOVANI2',
    HRACI2: 'HRACI2',
    IMPORT2: 'IMPORT2',
    KALENDAR: 'KALENDAR',
    KALENDAR2: 'KALENDAR2',
    KVALIFIKACE2: 'KVALIFIKACE2',
    LICENCE2: 'LICENCE2',
    LISTINY2: 'LISTINY2',
    MEGAMENU: 'MEGAMENU',
    MEGAMENU2: 'MEGAMENU2',
    MM: 'MM',
    MM2: 'MM2',
    MSMT2: 'MSMT2',
    NSA2: 'NSA2',
    ODDILY2: 'ODDILY2',
    OSOBNOSTI2: 'OSOBNOSTI2',
    PARTNERI: 'PARTNERI',
    PARTNERI2: 'PARTNERI2',
    PODATELNA2: 'PODATELNA2',
    PRESTUPY2: 'PRESTUPY2',
    PREVOD2: 'PREVOD2',
    PRISPEVKY2: 'PRISPEVKY2',
    RED2: 'RED2',
    REGISTRACE2: 'REGISTRACE2',
    REPREZENTACE: 'REPREZENTACE',
    REPREZENTACE2: 'REPREZENTACE2',
    ROZHODCI2: 'ROZHODCI2',
    ROZHODCI22: 'ROZHODCI22',
    RS2: 'RS2',
    SOUPISKY2: 'SOUPISKY2',
    SOUTEZE2: 'SOUTEZE2',
    SPORTOVISTE2: 'SPORTOVISTE2',
    SUPERUSER: 'SUPERUSER',
    TRANSFERY2: 'TRANSFERY2',
    UKOLY2: 'UKOLY2',
    VM: 'VM',
    YOUTUBE2: 'YOUTUBE2',
    LINKY2: 'LINKY2',
    SUPERSOUPISKY2: 'SUPERSOUPISKY2',
};
